var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "parentId",
                    label: "家长id",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入家长id" },
                    model: {
                      value: _vm.model.parentId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "parentId", $$v)
                      },
                      expression: "model.parentId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "memberId",
                    label: "会员id",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入会员id" },
                    model: {
                      value: _vm.model.memberId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "memberId", $$v)
                      },
                      expression: "model.memberId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "phone",
                    label: "手机号",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入手机号" },
                    model: {
                      value: _vm.model.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "phone", $$v)
                      },
                      expression: "model.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "amount",
                    label: "商品金额",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "amount", $$v)
                      },
                      expression: "model.amount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "name",
                    label: "商品名称",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入商品名称" },
                    model: {
                      value: _vm.model.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "code",
                    label: "商品编码",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入商品编码" },
                    model: {
                      value: _vm.model.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "code", $$v)
                      },
                      expression: "model.code",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "orderTime",
                    label: "下单时间",
                  },
                },
                [
                  _c("a-date-picker", {
                    attrs: { showTime: "", valueFormat: "YYYY-MM-DD HH:mm:ss" },
                    model: {
                      value: _vm.model.orderTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "orderTime", $$v)
                      },
                      expression: "model.orderTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "paymentTime",
                    label: "付款时间",
                  },
                },
                [
                  _c("a-date-picker", {
                    attrs: { showTime: "", valueFormat: "YYYY-MM-DD HH:mm:ss" },
                    model: {
                      value: _vm.model.paymentTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "paymentTime", $$v)
                      },
                      expression: "model.paymentTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "paymentType",
                    label: "支付类型 ",
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      ref: "select",
                      staticStyle: { width: "120px" },
                      model: {
                        value: _vm.model.paymentType,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "paymentType", $$v)
                        },
                        expression: "model.paymentType",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: 1 } }, [
                        _vm._v("微信支付"),
                      ]),
                      _c("a-select-option", { attrs: { value: 2 } }, [
                        _vm._v("支付宝支付"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "status",
                    label: "订单状态",
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      ref: "select",
                      staticStyle: { width: "120px" },
                      model: {
                        value: _vm.model.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "status", $$v)
                        },
                        expression: "model.status",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: 1 } }, [
                        _vm._v("已下单"),
                      ]),
                      _c("a-select-option", { attrs: { value: 2 } }, [
                        _vm._v("已付款"),
                      ]),
                      _c("a-select-option", { attrs: { value: 3 } }, [
                        _vm._v("订单作废）"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "tenantId",
                    label: "租户id",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.tenantId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "tenantId", $$v)
                      },
                      expression: "model.tenantId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }